import opportunitiesData from 'src/data/opportunities.json'

const getOpportunities = () => {
  return Promise.resolve({ data: opportunitiesData })
}

export default {
  getOpportunities,
}
